import React from 'react';
import { Heading } from '../../components/guide/Heading';
import HeaderPath from "../../components/common/HeaderPath";
import SectionBg from "../../assets/images/bg/profit_section_bg.png";
import SectionMobileBg from "../../assets/images/bg/profit_mobile_section_bg.svg";
import CtaBanner from "../../components/guide/CtaBanner";

const PrincipleProfitPage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
        <HeaderPath path={'> 분양의신 3원칙 > 고객이 실제로 돈을 벌게 만드는 광고'}/>
        <h1 className="hidden text-[36px] font-[700] lg:mb-[104px] lg:block lg:text-[47px]">
            <span className="mr-3 text-[#0000ED]">03</span> 고객이 실제로 돈을 벌게 만드는 광고
        </h1>
        <Heading as="p" size="subtitle" className="text-black font-[600] leading-relaxed">
            “이 광고로 고객이 얼마를 벌 수 있을까?”
        </Heading>

            <Heading as="p" size="subtitle" className="mt-4 text-black font-[400] leading-relaxed">
                분양의신은 광고를 기획할 때, 디자인을 만들 때, 매체를 세팅할 때, 항상 이 질문으로부터 시작합니다.<br/>
                노출이 몇만 건이고, 클릭이 몇천 건이었다는 숫자는 중요하지 않습니다.<br/>
                <br/>
                진짜 중요한 건 "그 결과 콜이 몇 건 왔고, 계약은 얼마나 성사됐으며, 고객님이 얼마를 벌었는가?"입니다.<br/>
                우리는 바로 그 수익의 숫자를 목표로 광고를 설계합니다.
            </Heading>
            <div className="mt-12 flex flex-col gap-12 sm:mt-16 lg:mt-[95px] lg:gap-[95px]">
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        📞 클릭보다 중요한 건 콜, 콜보다 중요한 건 계약
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        많은 광고 대행사는 “다양한 곳에 이만큼이나 노출 시킬 수 있습니다”를 성공 기준으로 삼습니다.<br/>
                        하지만 분양 현장에서 진짜 중요한 건<br/>
                        <div className={'mt-2 pl-2'}>
                            📌 전화를 몇 명이 했고<br/>
                            📌 그 중 몇 명이 현장에 왔으며<br/>
                            📌 결국 계약서를 누가 썼고,<br/>
                            📌 고객님이 그로 인해 얼마를 벌었는가입니다.<br/>
                        </div>
                        <span
                            className={'font-[700] mt-2 block'}>분양의신은 그 끝 숫자, “수익”이라는 단 하나의 지표만을 기준으로 광고를 평가합니다.</span>
                    </p>
                </div>
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        🧠 우리는 성과를 함께 만드는 파트너입니다
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        광고는 클릭에서 끝나지 않습니다.<br/>
                        콜 ➡️ 방문 ➡️ 계약 ➡️ 수익으로 이어지는 전환 흐름 전체를 설계해야 실질적인 성과가 나옵니다.<br/>
                        그래서 저희는 광고만 보지 않습니다.<br/>
                        콜 응대, DB 처리, 현장 대응 등 실제 계약에 영향을 주는 모든 접점을 함께 살펴봅니다.<br/>
                        <br/>
                        하지만 아무리 광고 데이터를 실시간으로 분석할 수 있다고 해도,<br
                        className={'hidden md:block'}/>
                        계약 수와 수익이 얼마인지는 고객님의 피드백 없이는 결코 알 수 없습니다.<br/>
                        <br/>
                        <span className={'font-[600]'}>그래서 저희는 파트너십 기반의 협업을 가장 중요하게 생각합니다.</span><br
                        className={'hidden md:block'}/>
                        <span className={'font-[600]'}>단순히 광고를 대행하는 것이 아니라, 성과를 함께 만들어가는 파트너로서 함께 움직입니다.</span><br/>
                        <br/>
                        고객님의 피드백이 더해질 때, 우리는 데이터 이상의 통찰로 전략을 설계할 수 있습니다.<br/>
                        그렇게 만들어진 캠페인은 더 정확하게, 더 빠르게 수익으로 연결됩니다.<br/>
                        <br/>
                        <span className={'font-[600]'}>신뢰를 나누고, 데이터를 공유하고, 성과를 함께 책임지는 구조.</span><br/>

                        <span className={'font-[600]'}>그것이 분양의신이 말하는 진짜 ‘성과 중심 광고’의 방식입니다.</span>
                    </p>
                </div>
                <div
                    className="block md:hidden rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionMobileBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'right'
                    }}>
                    분양의신이 만드는 건 단순한 광고가 아닙니다.<br/>
                    광고를 통해 고객의 수익을 만들고, 그 수익이 다시 고객의 성장을 이끄는 흐름을 함께 설계합니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    광고가 계약으로-계약이 수익으로-수익이 신뢰로 이어지는 선순환 구조.<br/>
                    그 중심에서 분양의신은 고객님과 함께 웃을 수 있는 회사를 지향합니다.
                </span>
                </div>
                <div
                    className="hidden md:block rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}>
                    분양의신이 만드는 건 단순한 광고가 아닙니다.<br/>
                    광고를 통해 고객의 수익을 만들고, 그 수익이 다시 고객의 성장을 이끄는 흐름을 함께 설계합니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    광고가 계약으로-계약이 수익으로-수익이 신뢰로 이어지는 선순환 구조.<br/>
                    그 중심에서 분양의신은 고객님과 함께 웃을 수 있는 회사를 지향합니다.
                </span>
                </div>
                <CtaBanner
                    message="광고로 웃을 수 있는 회사를 찾고 계신가요?"
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default PrincipleProfitPage;
